import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router";
import ReturnList from './ReturnList';
import ReturnListNoUser from './ReturnListNoUser';

@inject('commonStore','orderReturnStore')
@observer
class OrderReturnContainer extends Component {

  UNSAFE_componentWillMount() {
    this.props.orderReturnStore.setCommonStoreInfo(this.props.commonStore);
   
    this.props.orderReturnStore.onClear();
    this.props.orderReturnStore.disReturnList(1);
    const { sessionLoginInfo } = this.props.commonStore;
  }

  render() {
    const { sessionLoginInfo } = this.props.commonStore;
    return (
      <Fragment>
      {(sessionLoginInfo !== null && sessionLoginInfo.ceType !== undefined &&  sessionLoginInfo.ceType !== null) &&
        (sessionLoginInfo.cGbn === process.env.REACT_APP_TYPE_COMPANY_LGLOG) 
        ? <ReturnListNoUser
            ceType={(sessionLoginInfo !== null && sessionLoginInfo.ceType !== undefined &&  sessionLoginInfo.ceType !== null) 
              ? sessionLoginInfo.ceType : "" }
          />
        : <ReturnList
            ceType={(sessionLoginInfo !== null && sessionLoginInfo.ceType !== undefined &&  sessionLoginInfo.ceType !== null) 
              ? sessionLoginInfo.ceType : "" }
          />
      }
    </Fragment>
    );
  }

}

export default withRouter(OrderReturnContainer);
